import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";
import CustomLoadBoardSerializer from "../serializers/CustomLoadBoardSerializer";

export default class CustomLoadBoardRepository {
  CUSTOMLOADBOARD_BASE = "/api/customloadboard";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getCustomLoadBoardsByUser(instance, userId) {
    const token = await getToken(instance);
    const path = `${this.CUSTOMLOADBOARD_BASE}?userObjectId=${userId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers,
    });

    return Promise.resolve(req.customLoadBoards);
  }
  
  async createCustomLoadBoard(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CUSTOMLOADBOARD_BASE}/create`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({ customLoadBoard: CustomLoadBoardSerializer.serialize(payload) })
    });

    return Promise.resolve(CustomLoadBoardSerializer.deSerialize(req.customLoadBoard));
  }

  async updateCustomLoadBoard(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.CUSTOMLOADBOARD_BASE}/update`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ customLoadBoard: CustomLoadBoardSerializer.serialize(payload) })
    });

    return Promise.resolve(CustomLoadBoardSerializer.deSerialize(req.customLoadBoard));
  }
}